// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment} from 'react';
import cn from 'classnames';
import {Survey_page} from './surveys/survey_page';
import {Survey_progress} from './surveys/survey_progress';
import {use_survey} from './surveys/use_survey';
import {Button} from '../../../shared/button';
import Icon_navig_left2 from '../img/svg/navig/left2.svg';
import Icon_navig_right2 from '../img/svg/navig/right2.svg';
import {url2md5} from 'pub_config';
import styles from './surveys/survey.module.less';

interface i_survey_props {
    json: i_survey_json;
    country_code: string;
}
export const Survey = ({json, country_code}:i_survey_props)=>{
    const {title, pages, done_title, done_subtitle, done_img} = json;
    const {active, next, prev, answers, save, done} = use_survey(json,
        country_code);
    const next_available = pages[active].questions.every(q=>!!answers[q.id]);
    const cls = cn(styles.survey, done && styles.done);
    return <div className={cls}>
      <div className={styles.survey_header}>
        {!done && <h2 className={styles.title}>{title}</h2>}
        {(done || active > 0) && <Button caption="Back" on_click={prev}
          icon={<Icon_navig_left2 width={16} height={16}/>}
          cls={styles.back_btn} color={'transparent_grey'} size={'xs'}
        />}
        {!done && <Button caption="Skip" on_click={next}
          icon={<Icon_navig_right2 width={16} height={16}/>}
          cls={styles.skip_btn} color={'transparent_grey'} size={'xs'}
          reverse
        />}
      </div>
      {done ? <Fragment>
        <h2>{done_title}</h2>
        <h5>{done_subtitle}</h5>
        <img src={url2md5(`/www/hola/pub/img/${done_img}`)} alt="done"
          className="lazyload"/>
      </Fragment> : <Fragment>
        <Survey_progress max={pages.length} current={active}/>
        {pages.map((page, index)=>{
            return <Survey_page key={index} {...page} active={active==index}
              save={save}/>;
        })}
        <Button cls={styles.survey_next} on_click={next} caption="Next"
          size="lg" disabled={!next_available} arrow/>
      </Fragment>}
    </div>;
};
